import { I18N_INIT, I18N_SELECT } from "./I18nActions";

export function i18nReducer(
  state = {
    language: {
      key: "pt",
      alt: "Português",
      title: "Português"
    },
    languages: [],
    phrases: {}
  },
  action
) {
  switch (action.type) {
    case I18N_INIT:
      return { ...state, languages: action.payload };
    case I18N_SELECT:
      return {
        ...state,
        language: action.payload.language,
        phrases: action.payload.phrases
      };
    default:
      return state;
  }
}
